module.exports = __webpack_public_path__ + "img/page1.9b820592.png";